import axios from "axios";

class LevelUpRepository {
  createUser(params, callback) {
    axios.post("/v1/api/level-up/users", params)
    .then((res) => {
      if (res.status === 200)
        callback && callback(res.data);
    });
  }

  findUserDetail(callback) {
    axios.get("/v1/api/level-up/users/me")
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }
}

export { LevelUpRepository };
